import {
  Injectable,
  ApplicationRef,
  ComponentRef,
  Type,
  createComponent,
  EmbeddedViewRef
} from '@angular/core';
import { ModalComponent } from '@app/shared/modal/modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalComponentRef: ComponentRef<ModalComponent> | null = null;

  constructor(private appRef: ApplicationRef) {}

  open(options: {
    title?: string;
    textContent?: string;
    componentContent?: Type<any>;
    confirmButtonText?: string;
    saveButtonText?: string;
  }): void {
    if (this.modalComponentRef) return;

    // Create the component WITHOUT attaching to the CD tree yet so that all
    // @Input() properties are set before Angular's first change detection run.
    // This ensures ngAfterViewInit (which renders the dynamic content component)
    // sees the correct values - otherwise componentContent would be null when
    // ngAfterViewInit fires and renderContent() would silently do nothing.
    this.modalComponentRef = createComponent(ModalComponent, {
      environmentInjector: this.appRef.injector
    });

    const instance = this.modalComponentRef.instance;
    instance.title = options.title || null;
    instance.textContent = options.textContent || null;
    instance.componentContent = options.componentContent || null;
    instance.confirmButtonText = options.confirmButtonText || null;
    instance.saveButtonText = options.saveButtonText || null;

    instance.close.subscribe(() => this.close());
    instance.confirm.subscribe(() => this.close());

    // Attach AFTER all inputs are set - the first CD cycle will see correct values,
    // triggering ngAfterViewInit with componentContent already populated.
    this.appRef.attachView(this.modalComponentRef.hostView);
    const domElem = (this.modalComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
  }

  close(): void {
    if (this.modalComponentRef) {
      this.appRef.detachView(this.modalComponentRef.hostView);
      this.modalComponentRef.destroy();
      this.modalComponentRef = null;
    }
  }
}
